const minLength = 8;

export const criteria = {
  min: `At least ${minLength} characters`,
  alphabetic: "1 alphabetic value",
  number: "1 number",
  special: "1 special character",
};

const isAString = (password) =>
  typeof password === "string" || password instanceof String
    ? null
    : "Password should be a string";
const isAtLeast = (password) =>
  !!isAString(password) || password.length >= minLength ? null : criteria.min;
const containsAlphabetic = (password) =>
  !!isAString(password) ||
  password.split("").some((c) => c.toLowerCase() !== c.toUpperCase())
    ? null
    : criteria.alphabetic;
const containsNumeric = (password) =>
  !!isAString(password) ||
  password.split("").some((c) => Number.parseFloat(c) === +c)
    ? null
    : criteria.number;
const containsSpecial = (password) =>
  !!isAString(password) ||
  password.split("").some((c) => "#$^+=!*()@%&_-".includes(c))
    ? null
    : criteria.special;

const policies = [
  isAString,
  isAtLeast,
  containsAlphabetic,
  containsNumeric,
  containsSpecial,
];

export const validateConfirm = (password, confirm) => {
  const isValid = password === confirm;
  return { isValid, errors: isValid ? ["Password does not match"] : [] };
};
export const newValidatePassword = (password, user) => {
  const errors = policies
    .map((policy) => policy(password))
    .filter((e) => e !== null);

  const getEmail = () => {
    if (!user.emailAddress) return "";

    const [name, domain] = user.emailAddress.split("@");
    return `${name} ${domain.split(".")[0]}`;
  };

  const textNotValid = `${user.firstName} ${
    user.lastName
  } ${getEmail()}`.toLowerCase();

  const passToCompare = password.trim().toLowerCase();

  const isInPassword = textNotValid
    .toLowerCase()
    .split(" ")
    .some((text) => text.length > 0 && passToCompare.includes(text));

  if (isInPassword)
    errors.push("Cannot contain Participant's email address or name");

  const isValid = errors.length === 0 && !isInPassword;

  return { errors, isValid };
};
